import { AcademyMockApi } from 'app/z/mock-api/apps/academy/api';
import { AnalyticsMockApi } from 'app/z/mock-api/dashboards/analytics/api';
import { CalendarMockApi } from 'app/z/mock-api/apps/calendar/api';
import { ChatMockApi } from 'app/z/mock-api/apps/chat/api';
import { ContactsMockApi } from 'app/z/mock-api/apps/contacts/api';
import { ECommerceInventoryMockApi } from 'app/z/mock-api/apps/ecommerce/inventory/api';
import { FileManagerMockApi } from 'app/z/mock-api/apps/file-manager/api';
import { HelpCenterMockApi } from 'app/z/mock-api/apps/help-center/api';
import { IconsMockApi } from 'app/z/mock-api/ui/icons/api';
import { MailboxMockApi } from 'app/z/mock-api/apps/mailbox/api';
import { MessagesMockApi } from 'app/z/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/z/mock-api/common/navigation/api';
import { NotesMockApi } from 'app/z/mock-api/apps/notes/api';
import { NotificationsMockApi } from 'app/z/mock-api/common/notifications/api';
import { ProjectMockApi } from 'app/z/mock-api/dashboards/project/api';
import { SearchMockApi } from 'app/z/mock-api/common/search/api';
import { ShortcutsMockApi } from 'app/z/mock-api/common/shortcuts/api';
import { TasksMockApi } from 'app/z/mock-api/apps/tasks/api';

export const mockApiServices = [
    AcademyMockApi,
    AnalyticsMockApi,
    // AuthMockApi,
    CalendarMockApi,
    ChatMockApi,
    ContactsMockApi,
    ECommerceInventoryMockApi,
    FileManagerMockApi,
    HelpCenterMockApi,
    IconsMockApi,
    MailboxMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotesMockApi,
    NotificationsMockApi,
    ProjectMockApi,
    SearchMockApi,
    ShortcutsMockApi,
    TasksMockApi
];
